import "./CooperateBlock.css"
import SectionTitle from "../../../components/UI/SectionTitle/SectionTitle"
import SectionSubtitle from "../../../components/UI/SectionSubtitle/SectionSubtitle"
import { useQuery } from "react-query"
import { fetchsPartners } from "../../../api/api"
import { Box, CircularProgress } from "@mui/material"
import { NavLink } from "react-router-dom"
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react"
// Import Swiper styles
import "swiper/css"
import "swiper/css/navigation"
// import required modules
import { Navigation } from "swiper/modules"

const CooperateBlock = () => {
  const { data, isLoading, error } = useQuery("partners", fetchsPartners)

  return (
    <>
      <div className="container cooperate_con">
        <div className="cooperate_description">
          <div className="year_block">
            <p>2018- 2025</p>
          </div>
          <div className="text_block">
            <SectionTitle title="С нами сотрудничают" />
            <SectionSubtitle subtitle="Ваш вклад, наши технологии: сотрудничество, наполненное инновациями." />
            <p>
              Мы гордимся нашими партнерами, которые разделяют нашу страсть к технологиям. Совместно мы создаем
              технологические шедевры, приводим в жизнь новые идеи и строим успешные проекты.
            </p>
          </div>
        </div>
      </div>
      <div className="cooperate_icons">
        <div className="container">
          <div className="cooperate_icons_min">
            {isLoading ? (
              <Box
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <CircularProgress />
              </Box>
            ) : (
              <>
              <h1 className="cooperate_title">Наши партнеры</h1>
                {data?.length > 0 ? (
                  <div className="slider-container" style={{ position: "relative", padding: "0 40px" }}>
                    <Swiper
                      navigation={true}
                      modules={[Navigation]}
                      spaceBetween={20}
                      slidesPerView={1}
                      breakpoints={{
                        640: {
                          slidesPerView: 2,
                        },
                        768: {
                          slidesPerView: 3,
                        },
                        1024: {
                          slidesPerView: 4,
                        },
                      }}
                      className="partner-swiper"
                    >
                      {data?.map((item) => (
                        <SwiperSlide key={item?.id}>
                          <NavLink
                            className="cooperate_icon"
                            target={item?.url ? "_blank" : ""}
                            to={item?.url || "/"}
                            style={{
                              display: "block",
                              background: "#053352",
                              borderRadius: "8px",
                              padding: "20px",
                              height: "160px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              transition: "transform 0.3s ease",
                            }}
                          >
                            <img
                              src={item?.logo || "/placeholder.svg"}
                              alt="partner logo"
                              style={{
                                maxWidth: "100%",
                                maxHeight: "100%",
                                objectFit: "contain",
                              }}
                            />
                          </NavLink>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#fff",
                    }}
                  >
                    <h4>пусто</h4>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>

      <style>
        {`
          .partner-swiper {
            width: 100%;
            height: 100%;
          }

          .swiper-button-prev,
          .swiper-button-next {
            color: #000;
            background: white;
            width: 40px;
            height: 40px;
            border-radius: 50%;
            box-shadow: 0 2px 4px rgba(0,0,0,0.1);
          }

          .swiper-button-prev:after,
          .swiper-button-next:after {
            font-size: 20px;
          }

          .cooperate_icon:hover {
            transform: scale(1.05);
          }

          .swiper-button-prev {
            left: 0;
          }

          .swiper-button-next {
            right: 0;
          }
        `}
      </style>
    </>
  )
}

export default CooperateBlock

